function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function() {
    var elements = document.querySelectorAll('.js-block-scroll__element');
    var inputs = document.querySelectorAll('.js-block-scroll__input');

    inputs.forEach(function(input) {
        input.addEventListener('change', function() {
            elements.forEach(function(element) {
                if (!isHidden(element)) {
                    document.body.classList.add('block-scroll');
                } else {
                    document.body.classList.remove('block-scroll');
                }
            });
        });
    });

    function isHidden(el) {
        var style = window.getComputedStyle(el);
        return (style.display === 'none')
    }
});